import React, { Component } from 'react';
import {Divider, Header, Segment, Button, Message} from 'semantic-ui-react';
import { Formik, Form, Field } from 'formik';

import FormsInputsPassword from '../../inputs/password/forms_inputs_password';
import CommonUtility from "../../../../utils/CommonUtility";

class FormsRegisterPassword extends Component {
    state = {
        error: false,
        errorMessage: null,
        success: false
    }
    renderFormSubmissionResult() {
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there is an issue</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }

    render() {
        const {updateStepIndex, name, email} = this.props;
        return (
            <Formik
                initialValues={{
                    password: '',
                    confirmPassword: ''
                }}
                validateOnChange={false}
                validateOnBlur={false}
                // validationSchema={RegisterPasswordSchema}
                validate={(values) => {
                    // Additional Validation (if any)
                    let error = {};
                    if (values.password !== values.confirmPassword) {
                        error.confirmPassword = 'New passwords do not match.'
                    }   
                    else if(values.password.length < 8){
                        error.confirmPassword = 'Too short minimum 8 characters'
                    }
                    else if(values.password.length > 30){
                        error.confirmPassword = 'Too long maximum 30 characters'
                    }
                    if(!CommonUtility.isValidPasswordFormat(values.password)){
                        error.confirmPassword = 'Password must have 8 digits containing at least 1 uppercase, 1 lowercase, 1 numbers, and 1 special characters. (Combination of those 3 is fine)';
                    }
                    return error;
                }}
                onSubmit={(values, actions) => {
                    this.setState({error: false, errorMessage: null});
                    updateStepIndex(6, {password:values.password});
                }}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Segment>
                        <Form>
                            <Header as='h2'>
                                Set Up Password
                            </Header>
                            <Divider />
                            <Message info>
                                <Message.Header>
                                    {name}, secure your account!
                                </Message.Header>
                                <p>
                                    Please set up your password to proceed.
                                </p>
                                <p>
                                    Your password must be at least 8 characters long, include a number, an uppercase letter and a lowercase letter.
                                </p>
                            </Message>
                            <Field 
                                name="password" 
                                label="" 
                                component={FormsInputsPassword} 
                                secondaryLabel="Your new password"
                            />
                            <p>
                                &nbsp;
                            </p>
                            <Field 
                                name="confirmPassword" 
                                label="" 
                                component={FormsInputsPassword} 
                                secondaryLabel="Re-enter your new password"
                            />
                            &nbsp;
                            <Button type="submit" primary disabled={isSubmitting} fluid loading={isSubmitting}>Setup My Password & Activate Account</Button>
                            <p>
                                &nbsp;
                            </p>
                            {
                                this.renderFormSubmissionResult()
                            }
                        </Form>
                    </Segment>
                )}
            />
        );
    }
}

export default FormsRegisterPassword;